import { useEffect, useState } from 'react';
import Collapsible from 'react-collapsible';
import { images } from '../../../Constants/ImageUrls';
import {
  applyGesture,
  handleWidgetAccToUser,
} from '../../../Utils/productPageUtils';
import { categoryNameCollapsed, categoryNameExpanded } from './common';
import {
  Heading,
  SectionBody,
  SectionContainer,
  SectionTitle,
  TypeGrid,
} from './styled';

export default function Whatisit(props) {
  const {
    clickedHandler,
    productCategory,
    itemData,
    index,
    Ido,
    WidgetContainImage,
    clinic,
    showNewLandingPageUI,
  } = props;
  const widgetIsOpened = Ido || !itemData.default_collapsed;
  const [openWidget, setOpenWidget] = useState(widgetIsOpened);
  const [plusMinusDropDown, setPlusMinusDropDown] = useState(
    openWidget ? images.minusSvg : images.plusBlack,
  );
  const [gestureEffect, setGestureEffect] = useState();
  const [widgetHandle, setWidgetHandle] = useState({
    widgetImage: '',
    widgetClass: '',
  });
  const handleWidgetState = (categoryNameState, widgetOpen, imageType) => {
    applyGesture(setGestureEffect);
    clickedHandler(categoryNameState, index, itemData.title);
    // setOpenWidget(widgetOpen);
    setPlusMinusDropDown(imageType);
  };
  // useEffect(() => {
  //     setOpenWidget(showCollapsedView(index, WidgetContainImage));
  // }, [itemData]);
  useEffect(() => {
    handleWidgetAccToUser(plusMinusDropDown, setWidgetHandle);
  }, [plusMinusDropDown]);

  useEffect(() => {
    const state = widgetIsOpened;
    setOpenWidget(state);
  }, [itemData.default_collapsed]);

  useEffect(() => {
    if (openWidget)
      handleWidgetState(categoryNameExpanded, true, images.minusSvg);
    else handleWidgetState(categoryNameCollapsed, false, images.plusBlack);
  }, [openWidget]);

  return (
    <SectionContainer
      showNewLandingPageUI={showNewLandingPageUI}
      productcategory={productCategory}
    >
      <Collapsible
        trigger={
          <SectionTitle className={` ${gestureEffect} aplusTitleSize`}>
            {itemData.title}
            <img
              loading="lazy"
              src={widgetHandle.widgetImage}
              className={widgetHandle.widgetClass}
              alt="arrow"
            />
          </SectionTitle>
        }
        key={index}
        onOpening={() => {
          setOpenWidget(true);
        }}
        onClosing={() => {
          setOpenWidget(false);
        }}
        transitionTime={200}
        open={openWidget}
        triggerOpenedClassName="triggerClassAplus"
      >
        {itemData?.widgetContent?.map((item, index) => (
          <TypeGrid
            key={`gridWidget${index}`}
            contentalign={itemData?.content_align}
          >
            <SectionBody>
              {item.heading ? (
                <Heading>
                  <p>{item.heading}</p>
                </Heading>
              ) : null}
              <p> {item.body}</p>
            </SectionBody>
          </TypeGrid>
        ))}
      </Collapsible>
    </SectionContainer>
  );
}
